export default __webpack_public_path__ + "static/BYOD-Solutions-f602b03f03e81cc242b067772f5123c2.webp";